import React from "react";
import { cn } from "../../../lib/utils";
import { severityColor } from "../utils/gatewayUtils";

interface GatewaySeverityDotProps {
  severity: string;
  className?: string;
}

export default function GatewaySeverityDot({ severity, className }: GatewaySeverityDotProps) {
  return (
    <span className={cn("inline-flex items-center gap-1.5 text-xs", className)}>
      <span className={cn("w-2 h-2 rounded-full", severityColor(severity))} />
      {severity || "-"}
    </span>
  );
}
